import { PaymentError } from './PaymentError'

export class PaymentMethodMisconfiguredError extends PaymentError {
  constructor(message: string) {
    super(message, {
      type: '/errors/payment/misconfigured-payment-method',
    })
  }
}
